import React from 'react';

import { cn } from '../../lib/utils';

// App icons exported at 2x (72px) from the design library; keyed by template slug.
// `poll` has no template yet — it's on deck and picks up automatically once a
// template with that slug ships. Falls back to the staff-curated listing icon.
const WIDGET_TEMPLATE_APP_ICONS = Object.freeze({
  announcement_sticky_note: '/widget-icons/widget-app-announcement.png',
  assistant: '/widget-icons/widget-app-assistant.png',
  calendar: '/widget-icons/widget-app-calendar.png',
  github: '/widget-icons/widget-app-github.png',
  linear: '/widget-icons/widget-app-linear.png',
  links: '/widget-icons/widget-app-links.png',
  location: '/widget-icons/widget-app-location.png',
  poll: '/widget-icons/widget-app-poll.png',
  scribe: '/widget-icons/widget-app-scribe.png',
  to_do_list: '/widget-icons/widget-app-todo.png',
  venmo_fund: '/widget-icons/widget-app-venmo.png',
});

export function bundledTemplateIconUrl(template) {
  return WIDGET_TEMPLATE_APP_ICONS[template?.slug || template?.template_slug] || null;
}

export function templateIconUrl(template) {
  return bundledTemplateIconUrl(template) || template?.listing?.icon_url || null;
}

export function widgetIconUrl(widget) {
  return widget?.icon_url || null;
}

const WidgetIcon = React.memo(function WidgetIcon({ widget, className = 'size-4' }) {
  const resolvedIconUrl = widgetIconUrl(widget);
  if (!resolvedIconUrl) return null;

  return <img src={resolvedIconUrl} alt="" className={cn('aspect-square object-contain', className)} draggable="false" />;
});

export default WidgetIcon;
